<template>
	<div>
		<div class="box">
			<div class="row">
				<h2 class="match-header">Add Protopia Owner</h2>
			</div>
            <div class="configuration-reference">
				<!-- Protopia Owners -->
				<div class="card-row row">
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Owner Name</label>
							<md-input v-model.trim="ownerName" name="ownerName" v-validate="'required'" placeholder="Add Owner Name" @input="ownerName = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('ownerName')">{{errors.first('ownerName')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Owner Email</label>
							<md-input v-model.trim="ownerEmail" name="ownerEmail" id="ownerEmail" v-validate="'required|email'" placeholder="Add Owner Email" @input="ownerEmail = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('ownerEmail')">{{errors.first('ownerEmail')}}</p>
					</div>
				</div>

				<!-- Common save btn -->
				<div class="row">
					<div class="submitBtn">
						<md-button type="button" @click="saveOwner()" class="md-raised md-round md-accent">Save</md-button>
						<md-button type="button" @click="cancel()" class="md-raised md-round md-accent">Cancel</md-button>
					</div>
				</div>
            </div>
		</div>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from '@/utils/sanitizer';
export default {
    data() {
        return {
            fullPage: true,
            api: new API(),
            ownerName: '',
            ownerEmail: ''
        }
    },
    watch: {
      $route: "loadData"
    },
    created() {
		const dict = {
			custom: {
				ownerName: {
					required: () => 'Please enter Protopia Owner Name'
				},
				ownerEmail: {
					required: () => 'Please enter Protopia Owner Email',
                    email: () => 'Please enter valid Email'
				}
			}
		};
		this.$validator.localize('en', dict);
    },
    methods: {
        saveOwner: async function() {
			this.$validator.validateAll().then(async (result) => {
				if (result) {
                    let reqBody = {ownerName: this.ownerName, ownerEmail: this.ownerEmail}
					await this.api.post(`configuration/add-protopia-owner`, reqBody).then(responseData => {
						if (responseData.data && responseData.data.status) {
							this.$router.push('/configuration/reference-protopia-owner');
						} else {
							this.$toast.error(responseData.data.msg);
						}
					});
				}
			})
		},
		cancel: async function() {
			this.$router.push('/configuration/reference-protopia-owner');
		},
		sanitizeInput(event) {
			return sanitizeInput(event);
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfigurationProtopiaOwnerAdd.vue